// extracted by mini-css-extract-plugin
export default {"image":"aZ-z","loaded":"bZ-z"};